import { notify } from 'utils/reduxUtils';

export const types = {
  EDIT_TASK_ERROR: 'chat/tasks/EDIT_TASK_ERROR',
  EDIT_TASK_REQUEST: 'chat/tasks/EDIT_TASK_REQUEST',
  EDIT_TASK_SUCCESS: 'chat/tasks/EDIT_TASK_SUCCESS',
  TASK_ASSIGNMENT_RESET: 'chat/tasks/TASK_ASSIGNMENT_RESET',
  TASK_ASSIGNMENT_SET: 'chat/tasks/TASK_ASSIGNMENT_SET',
};

export const editTask = {
  error: notify(
    (error, taskId) => ({
      type: types.EDIT_TASK_ERROR,
      payload: { error, taskId },
    }),
    'Failed to save note',
  ),
  request: ({ assignedToId, dueDate, status, taskId }) => ({
    type: types.EDIT_TASK_REQUEST,
    payload: { assignedToId, dueDate, status, taskId },
  }),
  success: ({ taskId }) => ({
    type: types.EDIT_TASK_SUCCESS,
    payload: { taskId },
  }),
};

export const taskAssignment = {
  reset: () => ({
    type: types.TASK_ASSIGNMENT_RESET,
  }),
  set: ({ assignedUserFullName, assignedUserId, dueDate }) => ({
    type: types.TASK_ASSIGNMENT_SET,
    payload: { assignedUserFullName, assignedUserId, dueDate },
  }),
};
